import styled from 'styled-components';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';

const StepperFormControlLabel = styled(FormControlLabel).attrs({ weight: 'regular' })`
  font-size: ${({ theme }) => theme.text.paragraph.md.fontSize};
`;

export default StepperFormControlLabel;
